module.exports = __webpack_public_path__ + "img/smart_tv_app.064d8b7a.svg";